import { FC, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import SimpleProgressBar from "@/components/SimpleProgressBar";
import { theme } from "tailwind.config";
import { Autoplay, EffectFade } from "swiper/modules";

type Props = {
  imageUrls: string[];
  wrapperClassName?: string;
};

const SimpleSlideshow: FC<Props> = ({
  imageUrls,
  wrapperClassName,
}): JSX.Element => {
  const [percentage, setPercentage] = useState(1);

  return (
    <div className={["relative", wrapperClassName].join(" ")}>
      <div className="absolute w-full h-full inset-0">
        <Swiper
          className="w-full h-full"
          effect="fade"
          loop={true}
          autoplay={{
            delay: 5000,
          }}
          speed={1000}
          modules={[EffectFade, Autoplay]}
          onAutoplayTimeLeft={(_a, _b, percentage) => setPercentage(percentage)}
        >
          {imageUrls.map((url) => (
            <SwiperSlide key={url}>
              <div
                className="absolute w-full h-full inset-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${url})` }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {imageUrls.length > 1 && (
          <div className="absolute bottom-0 inset-x-0 w-full z-[1]">
            <SimpleProgressBar
              backgroundColor={theme.colors.gray[100]}
              barColor={theme.colors.gray[950]}
              percentage={1 - percentage}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default SimpleSlideshow;
